<template>
  <div id="workScroll" class="block">
      <div id="scroll_content" :class="{mobile : isMobile}">
      <div v-if="!isMobile" id="emptyspace_start"></div>
      <HomepageProject :project="allProjects[0]" id="centerThis"/>
      <HomepageProject v-for="project in allProjects.slice(1, allProjects.length)" :key="project.id" :project="project"/>
      <div id="emptyspace_end"></div>
    </div>
  </div>
</template>

<script>
import HomepageProject from '@/components/HomepageProject.vue'

export default {
  name: "WorkScroll",
  components: {
    HomepageProject
  },
  props: ['allProjects', 'isMobile'],
}
</script>

<style>
#workScroll {
  width:100%;
  left:0;
  z-index: 10;
}

#emptyspace_end, #emptyspace_start {
  height:18vh;
}

#scroll_content {
  width:100%;
}

#scroll_content.mobile {
  margin-top:50px;
  width:100%;
}
</style>